<template>
  <div class="app-container">
    <Container
      :title="t('process.processEdit')"
      :hasLine="true"
    >
      <template #main>
        <el-form
          :label-width="labelWidth"
          ref="cFormRef"
          label-position="left"
          style="margin-left:120px;"
        >
          <el-row
            :gutter="5"
            style="width:100%;min-width:1450px"
          >
            <el-col :span="8">
              <el-form-item
                :label="t('process.processName')"
                label-width="180px"
              >
                <span>{{ detailData.name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('process.companyName')"
                label-width="180px"
              >
                <span>{{ detailData.companyName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            style="width:100%;min-width:1450px"
          >
            <el-col :span="14">
              <el-form-item
                :label="t('process.isActive')"
                label-width="180px"
              >
                <el-radio-group
                  v-model="uiIsActive"
                  disabled
                >
                  <el-radio
                    v-for="(option, optionIndex) in activeOptions"
                    :key="optionIndex"
                    :label="option.value"
                  >
                    {{ option.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            style="width:100%;min-width:1450px"
          >
            <el-col :span="14">
              <el-form-item
                :label="t('process.processLine')"
                label-width="180px"
              />
            </el-col>
          </el-row>
        </el-form>
        <el-form
          :label-width="labelWidth"
          ref="cFormRef1"
          label-position="left"
          style="margin-left:152px;"
        >
          <el-row
            :gutter="5"
            style="width:100%;min-width:1450px"
          >
            <el-col :span="8">
              <el-form-item
                :label="t('process.level1Approver')"
                label-width="145px"
              >
                <ul class="group-card">
                  <li
                    v-for="(item, index) in detailData.level1"
                    :key="item.id"
                    :class="{bg: index === level1SelectIndex}"
                    @click="selectLevel1Item(index)"
                  >
                    {{ item.userName }}, {{ item.userAccount }}, {{ item.mailAddress }}
                  </li>
                </ul>
              </el-form-item>
            </el-col>
            <el-col
              :span="2"
              :offset="3"
            >
              <div class="custom-button-container">
                <el-button
                  class="custom-button-item"
                  type="primary"
                  @click="showDialogLevel1Approver"
                >
                  {{ t('process.addApprover') }}
                </el-button>
                <el-button
                  class="custom-button-item"
                  @click="deleteSelectedLevel1Item"
                >
                  {{ t('process.deleteApprover') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-row
            v-if="showProcessLevel >= 2"
            :gutter="5"
            style="width:100%;min-width:1450px"
          >
            <el-col :span="8">
              <el-form-item
                :label="t('process.level2Approver')"
                label-width="145px"
              >
                <ul class="group-card">
                  <li
                    v-for="(item, index) in detailData.level2"
                    :key="item.id"
                    :class="{bg: index === level2SelectIndex}"
                    @click="selectLevel2Item(index)"
                  >
                    {{ item.userName }}, {{ item.userAccount }}, {{ item.mailAddress }}
                  </li>
                </ul>
              </el-form-item>
            </el-col>
            <el-col
              :span="2"
              :offset="3"
            >
              <div class="custom-button-container">
                <el-button
                  class="custom-button-item"
                  type="primary"
                  @click="showDialogLevel2Approver"
                >
                  {{ t('process.addApprover') }}
                </el-button>
                <el-button
                  class="custom-button-item"
                  @click="deleteSelectedLevel2Item"
                >
                  {{ t('process.deleteApprover') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-row
            v-if="showProcessLevel >= 3"
            :gutter="5"
            style="width:100%;min-width:1450px"
          >
            <el-col :span="8">
              <el-form-item
                :label="t('process.level3Approver')"
                label-width="145px"
              >
                <ul class="group-card">
                  <li
                    v-for="(item, index) in detailData.level3"
                    :key="item.id"
                    :class="{bg: index === level3SelectIndex}"
                    @click="selectLevel3Item(index)"
                  >
                    {{ item.userName }}, {{ item.userAccount }}, {{ item.mailAddress }}
                  </li>
                </ul>
              </el-form-item>
            </el-col>
            <el-col
              :span="2"
              :offset="3"
            >
              <div class="custom-button-container">
                <el-button
                  class="custom-button-item"
                  type="primary"
                  @click="showDialogLevel3Approver"
                >
                  {{ t('process.addApprover') }}
                </el-button>
                <el-button
                  class="custom-button-item"
                  @click="deleteSelectedLevel3Item"
                >
                  {{ t('process.deleteApprover') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-row
            :gutter="5"
            style="width:100%;min-width:1450px"
          >
            <el-col
              :span="100"
              :offset="6"
            >
              <div class="save-button">
                <el-button
                  class="custom-button-submit"
                  type="primary"
                  @click="onSaveApproverUpdate()"
                >
                  {{ t('common.save') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </Container>
    <el-dialog
      width="40%"
      v-model="dialogShowApprover"
    >
      <div
        style="text-align: center; padding-bottom: 120px;"
      >
        <el-select
          style="width: 85%"
          v-model="dialogApproverSelectUserId"
          ref="selectIt"
          placeholder="请选择"
          clearable
          filterable
        >
          <template #prefix>
            <i class="el-icon-search" />
          </template>
          <el-option
            v-for="(item,index) in approverOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div
        class="dialog-footer"
        style="text-align: right;"
      >
        <el-button @click="dialogShowApprover = false">
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          @click="levelApproverSelectConfirm(dialogLevelType)"
        >
          {{ t("table.confirm") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { getProcessDetailById, getUserList, saveProcess } from '@/apis/process/process'
import {
  ApproverOptionsModel,
  ApproverUserListParamModel,
  ApproverUserModel, ProcessApprover,
  ProcessDetailModel, ProcessUpdateParamModel
} from '@/model/process/processModel'
import Container from '@/components/form/container/Container.vue'
import { ElLoading, ElMessage, ElSelect } from 'element-plus'

export default defineComponent({
  props: {
    labelWidth: {
      type: String,
      default: '480px'
    }
  },
  components: {
    Container
  },
  setup() {
    const { t } = useI18n()
    const id = useRoute().params.id.toString()
    const selectIt = ref(ElSelect)
    const dataMap = reactive({
      detailData: {} as ProcessDetailModel | null,
      listLoading: true,
      uiIsActive: true,
      showProcessLevel: 0,
      activeOptions: [
        { label: t('process.yes'), value: true },
        { label: t('process.no'), value: false }
      ],
      itemsTest: ref([{ id: 1, message: 'Foo' }, { id: 2, message: 'Bar' }]),
      level1SelectIndex: -1,
      level2SelectIndex: -1,
      level3SelectIndex: -1,
      dialogApproverSelectUserId: null,
      dialogShowApprover: false,
      dialogLevelType: 0,
      approverOptions: Array<ApproverOptionsModel>(),
      users: Array<ApproverUserModel>(),
      async getDetail() {
        dataMap.listLoading = true
        const data = await getProcessDetailById(id)
        if (data && data.data) {
          dataMap.detailData = data.data
          dataMap.uiIsActive = dataMap.detailData?.active || false
          if (dataMap.detailData && dataMap.detailData?.levelCount) {
            dataMap.showProcessLevel = dataMap.detailData?.levelCount
          }
        }
        const params: ApproverUserListParamModel = {
          userName: '',
          userRoleNames: '',
          userAccount: '',
          active: true
        }
        const userData = await getUserList(params)
        if (userData && userData.data && userData.data.length > 0) {
          dataMap.users = userData.data
          dataMap.approverOptions = userData.data.map(
            (item) => ({
              value: item.userId,
              label: item.userName + ', ' + item.userAccount + ', ' + item.mailAddress
            })
          )
        }
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      selectLevel1Item(index: number) {
        dataMap.level1SelectIndex = index
      },
      selectLevel2Item(index: number) {
        dataMap.level2SelectIndex = index
      },
      selectLevel3Item(index: number) {
        dataMap.level3SelectIndex = index
      },
      showDialogLevel1Approver() {
        dataMap.dialogApproverSelectUserId = null
        dataMap.dialogShowApprover = true
        dataMap.dialogLevelType = 1
      },
      showDialogLevel2Approver() {
        dataMap.dialogApproverSelectUserId = null
        dataMap.dialogShowApprover = true
        dataMap.dialogLevelType = 2
      },
      showDialogLevel3Approver() {
        dataMap.dialogApproverSelectUserId = null
        dataMap.dialogShowApprover = true
        dataMap.dialogLevelType = 3
      },
      levelApproverSelectConfirm(levelType: number) {
        switch (levelType) {
          case 1: { // Select level1 Approver id
            const foundItem = dataMap.detailData?.level1.find(obj => obj.userId === dataMap.dialogApproverSelectUserId)
            if (foundItem !== null && typeof (foundItem) !== 'undefined') {
              ElMessage({
                message: t('process.hasApprover'),
                type: 'success',
                duration: 2000
              })
            } else {
              const user = dataMap.users.find(obj => obj.userId === dataMap.dialogApproverSelectUserId)
              const approver: ProcessApprover = {
                id: null,
                processId: dataMap.detailData?.level1[0]?.processId as number,
                level: 1,
                userId: user?.userId as number,
                userName: user?.userName as string,
                userRoleNames: user?.userRoleNames as string,
                userAccount: user?.userAccount as string,
                mailAddress: user?.mailAddress as string
              }
              // eslint-disable-next-line no-unused-expressions
              dataMap.detailData?.level1.push(approver)
            }
            break
          }
          case 2: { // Select level2 Approver id
            const foundItem = dataMap.detailData?.level2.find(obj => obj.userId === dataMap.dialogApproverSelectUserId)
            if (foundItem !== null && typeof (foundItem) !== 'undefined') {
              ElMessage({
                message: t('process.hasApprover'),
                type: 'success',
                duration: 2000
              })
            } else {
              const user = dataMap.users.find(obj => obj.userId === dataMap.dialogApproverSelectUserId)
              const approver: ProcessApprover = {
                id: null,
                processId: dataMap.detailData?.level2[0]?.processId as number,
                level: 1,
                userId: user?.userId as number,
                userName: user?.userName as string,
                userRoleNames: user?.userRoleNames as string,
                userAccount: user?.userAccount as string,
                mailAddress: user?.mailAddress as string
              }
              // eslint-disable-next-line no-unused-expressions
              dataMap.detailData?.level2.push(approver)
            }
            break
          }
          case 3: { // Select level3 Approver id
            const foundItem = dataMap.detailData?.level3.find(obj => obj.userId === dataMap.dialogApproverSelectUserId)
            if (foundItem !== null && typeof (foundItem) !== 'undefined') {
              ElMessage({
                message: t('process.hasApprover'),
                type: 'success',
                duration: 2000
              })
            } else {
              const user = dataMap.users.find(obj => obj.userId === dataMap.dialogApproverSelectUserId)
              const approver: ProcessApprover = {
                id: null,
                processId: dataMap.detailData?.level3[0]?.processId as number,
                level: 1,
                userId: user?.userId as number,
                userName: user?.userName as string,
                userRoleNames: user?.userRoleNames as string,
                userAccount: user?.userAccount as string,
                mailAddress: user?.mailAddress as string
              }
              // eslint-disable-next-line no-unused-expressions
              dataMap.detailData?.level3.push(approver)
            }
            break
          }
          default:
            console.log('超出范围')
        }
        dataMap.dialogShowApprover = false
      },
      deleteSelectedLevel1Item() {
        if (dataMap.level1SelectIndex !== -1) {
          if (dataMap.detailData !== null) {
            dataMap.detailData.level1.splice(dataMap.level1SelectIndex, 1)
            dataMap.level1SelectIndex = -1 // 重置选中项索引
          }
        }
      },
      deleteSelectedLevel2Item() {
        if (dataMap.level2SelectIndex !== -1) {
          if (dataMap.detailData !== null) {
            dataMap.detailData.level2.splice(dataMap.level2SelectIndex, 1)
            dataMap.level2SelectIndex = -1 // 重置选中项索引
          }
        }
      },
      deleteSelectedLevel3Item() {
        if (dataMap.level3SelectIndex !== -1) {
          if (dataMap.detailData !== null) {
            dataMap.detailData.level3.splice(dataMap.level3SelectIndex, 1)
            dataMap.level3SelectIndex = -1 // 重置选中项索引
          }
        }
      },
      async onSaveApproverUpdate() {
        if (dataMap.detailData !== null) {
          if (dataMap.detailData.levelCount !== null) {
            switch (dataMap.detailData.levelCount) {
              case 1:
                // 承兑票审批流
                if (dataMap.detailData.level1.length < 1) {
                  ElMessage({
                    message: t('process.ApproverEmpty'),
                    type: 'error',
                    duration: 2000
                  })
                  return
                }
                break
              case 3:
                // 审批流
                if (dataMap.detailData.level1.length < 1 ||
                  dataMap.detailData.level2.length < 1 ||
                  dataMap.detailData.level3.length < 1) {
                  ElMessage({
                    message: t('process.ApproverEmpty'),
                    type: 'error',
                    duration: 2000
                  })
                  return
                }
                break
              default:
                break
            }
          }
          const loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const processParam: ProcessUpdateParamModel = {
            id: dataMap.detailData.id,
            levelCount: dataMap.detailData.levelCount,
            level1: dataMap.detailData.level1,
            level2: dataMap.detailData.level2,
            level3: dataMap.detailData.level3
          }
          const result = await saveProcess(processParam)
          if (result?.data && result?.data > 0) {
            ElMessage({
              message: t('common.updateSuccess'),
              type: 'success',
              duration: 2000
            })
          } else {
            ElMessage({
              message: result?.msg,
              type: 'error',
              duration: 2000
            })
          }
          loading.close()
        }
      }
    })
    onMounted(() => {
      dataMap.getDetail()
    })
    return {
      t,
      selectIt,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style scoped lang="scss">
.group-card {
  height: 160px;
  width: 480px;
  border: 1px solid #e4e7ed;
  margin: 0;
  background: #fff;
  list-style-type: none;
  padding: 0px 0;
  overflow-y: auto;
  li {
    margin: 0;
    padding: 2px 16px;
    cursor: pointer;
    height: 40px;
    &:hover {
      background: #eee;
    }
  }
  .bg {
    background-color: #0971cd;
    color: #fff;
  }
}

.custom-button-container {
  display: flex;
  flex-direction: column; /* 设置主轴为垂直方向 */
  align-items: center;
  gap: 10px; /* 按钮之间的间距 */
}

.custom-button-item {
  margin-left:0px;
  width: 110px;
  justify-content: center;
}

.custom-button-submit {
  width: 110px;
  justify-content: center;
}

.custom-dialog {
  height: 570px;
  overflow: hidden;
}

</style>
